import { Sun } from 'lucide-react';
import { useOutdoor } from '../lib/outdoor';

/** The header's Outdoor switch (#707): one tap for the high-contrast look, another for today's. */
export function OutdoorToggle() {
  const [on, setOn] = useOutdoor();
  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      onClick={() => setOn(!on)}
      title={on ? 'Outdoor is on: tap for the normal look' : 'Outdoor: high contrast for bright sun'}
      className={`flex min-h-11 shrink-0 items-center gap-1.5 rounded-full border px-3 text-sm font-medium ${on ? 'border-slate-900 bg-slate-900 text-white' : 'border-slate-300 bg-white text-slate-700'}`}
    >
      <Sun className="h-4 w-4" aria-hidden="true" />
      Outdoor
      <span className="text-xs opacity-90" aria-hidden="true">{on ? 'On' : 'Off'}</span>
    </button>
  );
}
